import { render, staticRenderFns } from "./EventCategories.vue?vue&type=template&id=3e7a3dfc&scoped=true&"
import script from "./EventCategories.vue?vue&type=script&lang=js&"
export * from "./EventCategories.vue?vue&type=script&lang=js&"
import style0 from "./EventCategories.vue?vue&type=style&index=0&id=3e7a3dfc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7a3dfc",
  null
  
)

export default component.exports